import { render, staticRenderFns } from "./page-userlist.vue?vue&type=template&id=2a4007a8&scoped=true&lang=html&"
import script from "./page-userlist.vue?vue&type=script&lang=js&"
export * from "./page-userlist.vue?vue&type=script&lang=js&"
import style0 from "./page-userlist.vue?vue&type=style&index=0&id=2a4007a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4007a8",
  null
  
)

export default component.exports